import React from "react";
import { Resource } from "react-admin";
import ArticleDppList from "./ArticleDpp/ArticleDppList";
import ArticleDppShow from "./ArticleDpp/ArticleDppShow";

const articleDppResource = () => (
  <Resource
    name="articleDpp"
    options={{ label: "Article DPP", menuGroup: "Articles" }}
    list={ArticleDppList}
    show={ArticleDppShow}
  />
);

export default articleDppResource;
